module.exports = __webpack_public_path__ + "img/oye-lucky.5628d2aa.svg";